export var getSupportedNodesForAIModal = function getSupportedNodesForAIModal(_ref) {
  var nodes = _ref.schema.nodes;
  return new Set([nodes.table]);
};
export var isCellSelection = function isCellSelection(state, selection) {
  var _state$schema$nodes = state.schema.nodes,
    tableHeader = _state$schema$nodes.tableHeader,
    tableCell = _state$schema$nodes.tableCell,
    tabeRow = _state$schema$nodes.tabeRow,
    table = _state$schema$nodes.table;
  var _ref2 = selection || state.selection,
    $from = _ref2.$from;
  var parent = $from.parent;
  return [tableHeader, tableCell, tabeRow, table].includes(parent.type);
};